// PATH: src/index.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import theme from './theme';
import './index.css';

// 👇 importa tus providers
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ConfirmProvider } from './components/common/ConfirmDialog';

const root = createRoot(document.getElementById('root'));

root.render(
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <AdminAuthProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  </ChakraProvider>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('[ServiceWorker] Registration successful with scope: ', registration.scope);
      },
      (err) => {
        console.log('[ServiceWorker] Registration failed: ', err);
      }
    );
  });
}
